import { router } from '@/pages/default/router';

export const navigateTo = (uri) => {
  router.push(uri);
};
